module.exports = __webpack_public_path__ + "img/positive_feedback.svg";